/**
 * DESIGNER RÜCKSEITE – Erweiterung für designer-preview.js
 * Rückseite des Topfes zusätzlich gravieren (bis 3 Textzeilen, gleiche Schrift).
 * - Reiter „Vorderseite / Rückseite" in der Vorschau
 * - Eigenschaften „Rückseite Zeile 1–3" an der Topf-Position
 * - Zusatzposition „Gravur der Rückseite" (window.DESIGNER_RUECKSEITE_VARIANT)
 *   wird VOR dem Topf in den Warenkorb gelegt, danach läuft der normale
 *   Theme-Ablauf (Warenkorb-Drawer zeigt beide Positionen).
 */
(function () {
  'use strict';

  var LINES = ['designer-back-line1', 'designer-back-line2', 'designer-back-line3'];

  function $(id) { return document.getElementById(id); }

  // designer-preview.js legt DesignerPreview als const an (kein window-Property):
  // aus einem anderen klassischen Skript ist die Bindung trotzdem erreichbar.
  function DP() {
    try { return DesignerPreview; } catch (e) { return window.DesignerPreview; }
  }

  function aktiv() {
    var t = $('designer-back-toggle');
    return !!(t && t.checked);
  }

  function backData() {
    var dp = DP();
    var front = dp ? dp.getFormData() : { font: 'Pixie Ring' };
    return {
      line1: ($('designer-back-line1') || {}).value || '',
      line2: ($('designer-back-line2') || {}).value || '',
      line3: ($('designer-back-line3') || {}).value || '',
      line4: '',
      font: front.font,
      iconNumber: ''
    };
  }

  // ---------- Eingabeblock auf-/zuklappen + Eigenschaften synchronisieren
  function syncHidden() {
    var an = aktiv();
    var flag = $('designer-hidden-back');
    if (flag) { flag.value = an ? 'Ja' : ''; flag.disabled = !an; }
    LINES.forEach(function (id, i) {
      var h = $('designer-hidden-back-line' + (i + 1));
      if (h) { h.value = an ? (($(id) || {}).value || '') : ''; h.disabled = !an; }   // aus = gar nicht mitschicken
    });
  }

  function toggleFields() {
    var tabs = $('preview-side-tabs');
    if (tabs) { tabs.style.display = 'flex'; }           // Reiter immer da, Schalter sitzt im Rückseiten-Reiter
    var box = $('designer-back-fields');
    if (box) { box.classList.toggle('aus', !aktiv()); }
    syncHidden();
    varianteSetzen();
    setTimeout(hinweisAktualisieren, 80);
    if (currentSide === 'back') { renderBack(); }
  }

  // ---------- Vorschau: Seite wechseln
  var currentSide = 'front';

  async function renderBack() {
    var dp = DP();
    if (!dp || !dp.ctx) { return; }
    if (dp.isRendering) { return; }
    dp.isRendering = true;
    try {
      if (!dp.fontsLoaded) { await dp.loadFonts(); }
      dp.ctx.clearRect(0, 0, dp.config.canvasWidth, dp.config.canvasHeight);
      if (dp.images.base && dp.images.base.complete) {
        dp.ctx.drawImage(dp.images.base, 0, 0, dp.config.canvasWidth, dp.config.canvasHeight);
      }
      var d = backData();
      // Bis 3 Zeilen, vertikal mittig auf dem Topf (Positionen der Vorderseite 2–4 nutzen)
      var cfg = dp.config.textConfig;
      var slots = [cfg.line1, cfg.line2, cfg.line3];
      var texte = [d.line1, d.line2, d.line3].filter(function (t) { return t; });
      var start = texte.length === 1 ? 1 : (texte.length === 2 ? 0 : 0);
      var fontData = dp.config.fontConfig[d.font];        // Rückseite in der gewählten Schrift (wie vorne)
      var fontName = fontData ? fontData.name : 'Pixie Ring';
      dp.ctx.fillStyle = cfg.color;
      dp.ctx.textAlign = 'center';
      dp.ctx.textBaseline = 'middle';
      // Rückseite: gleiche Schrift, aber ~20 % kleiner (Taras 27.09.), Zeilen enger und mittig
      var abstand = 54;                                   // alle Zeilen gleich groß, mittig
      var mitte = cfg.line2.y + 20;
      var y0 = mitte - ((texte.length - 1) * abstand) / 2;
      dp.ctx.font = Math.round(cfg.line1.fontSize * 0.8) + 'px "' + fontName + '"';
      texte.forEach(function (t, i) { dp.ctx.fillText(t, cfg.line1.x, y0 + i * abstand); });
      if (!texte.length || !aktiv()) {
        dp.ctx.clearRect(0, 0, dp.config.canvasWidth, dp.config.canvasHeight);
        if (dp.images.base && dp.images.base.complete) { dp.ctx.drawImage(dp.images.base, 0, 0, dp.config.canvasWidth, dp.config.canvasHeight); }
        dp.ctx.font = '30px "Montserrat"';
        dp.ctx.fillStyle = '#9aa39b';
        dp.ctx.fillText(aktiv() ? 'Rückseite: noch kein Text' : 'Rückseite ohne Gravur', cfg.line2.x, cfg.line2.y);
      }
    } catch (e) {
      console.error('Rückseite rendern:', e);
    } finally {
      dp.isRendering = false;
    }
  }

  function showSide(side) {
    var dp = DP();
    currentSide = side;
    var tabs = document.querySelectorAll('#preview-side-tabs button');
    tabs.forEach(function (b) { b.classList.toggle('active', b.dataset.side === side); });
    var felder = $('designer-back-fields');
    if (felder) { felder.style.display = (side === 'back') ? 'block' : 'none'; }
    if (!dp) { return; }
    if (side === 'back') { renderBack(); } else { dp.renderPreview(dp.getFormData()); }
  }


  // ---------- Hinweis am Preis: „Komplettset · Vorder- und Rückseite graviert"
  function hinweisAktualisieren() {
    var preis = document.querySelector('.product__price-and-ratings') || document.querySelector('.product__price');
    if (!preis) { return; }
    var el = document.getElementById('nm-konfig-hinweis');
    if (!el) {
      el = document.createElement('div');
      el.id = 'nm-konfig-hinweis';
      el.style.cssText = 'font-size:13px;color:#115E16;margin:2px 0 6px;font-weight:600;';
      preis.parentNode.insertBefore(el, preis.nextSibling);
    }
    var ausf = document.querySelector('select[name="options[Ausführung]"]');
    var ausfText = ausf ? ausf.value : '';
    el.textContent = (ausfText ? ausfText + ' · ' : '') + (aktiv() ? 'Vorder- und Rückseite graviert (+ 8,00 €)' : 'nur Vorderseite graviert');
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('select[name^="options["]')) { setTimeout(hinweisAktualisieren, 50); }
  }, true);

  // ---------- Variante umschalten (Option „Rückseite": ohne / mit)
  // Der Aufpreis steckt in eigenen Varianten. Der Kachel-Picker zeigt nur die
  // „ohne"-Varianten; das Häkchen setzt das versteckte Options-Select der zweiten
  // Option, worauf das Theme Preis, Variante und Warenkorb-Knopf selbst aktualisiert.
  var OPTION = window.DESIGNER_RUECKSEITE_OPTION || 'Rückseite';

  function optionSelect() {
    return document.querySelector('select[name="options[' + OPTION + ']"]');
  }

  function varianteSetzen() {
    var sel = optionSelect();
    if (!sel) { return; }
    var werte = Array.prototype.map.call(sel.options, function (o) { return o.value; });
    var ziel = aktiv() ? (werte.find(function (w) { return /mit/i.test(w); }) || werte[1]) : werte[0];
    if (!ziel || sel.value === ziel) { return; }
    sel.value = ziel;
    sel.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
  }

  function kachelWechselAbfangen() {
    // Ein Klick auf eine Ausführungs-Kachel setzt alle Options-Selects auf die Kachel-
    // Variante („ohne"). Danach die Rückseite wieder anwenden, falls angehakt.
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) { return; }
      if (!e.target.closest('.variant-option-card')) { return; }
      setTimeout(varianteSetzen, 60);
      setTimeout(varianteSetzen, 400);
    }, true);
  }


  // ---------- Beim (Wieder-)Laden immer ohne Rückseite starten (01.10.2026)
  // Browser stellen beim Zurückgehen/Neuladen das Häkchen wieder her, die Textfelder
  // im Vorschau-Fenster aber nicht -> „mit Rückseite" war vorausgewählt, aber leer.
  // Nichts merken: Rückseite immer aus und leer, Kunde gibt sie bei Bedarf neu ein.
  var nutzerHatEingegeben = false;
  document.addEventListener('input', function (e) { if (e.isTrusted) { nutzerHatEingegeben = true; } }, true);
  document.addEventListener('change', function (e) { if (e.isTrusted) { nutzerHatEingegeben = true; } }, true);

  function zuruecksetzen() {
    var t = $('designer-back-toggle');
    if (t) { t.checked = false; }
    LINES.forEach(function (id) { var el = $(id); if (el) { el.value = ''; } });
    toggleFields();
  }

  // ---------- Start
  function init() {
    var toggle = $('designer-back-toggle');
    if (!toggle) { return; }
    // Ohne Varianten-Option „Rückseite" am Produkt gibt es keinen Aufpreis –
    // dann Reiter und Felder gar nicht erst anbieten.
    if (!optionSelect()) {
      var tabs0 = $('preview-side-tabs'); if (tabs0) { tabs0.remove(); }
      var box0 = $('designer-back-fields'); if (box0) { box0.remove(); }
      return;
    }
    toggle.addEventListener('change', toggleFields);
    LINES.forEach(function (id) {
      var el = $(id);
      if (!el) { return; }
      el.addEventListener('input', function () {
        // Wer tippt, will die Rückseite: Schalter automatisch setzen
        var t = $('designer-back-toggle');
        if (t && !t.checked && el.value.trim()) { t.checked = true; toggleFields(); return; }
        syncHidden();
        if (currentSide === 'back') { renderBack(); }
      });
    });
    document.querySelectorAll('#preview-side-tabs button').forEach(function (b) {
      b.addEventListener('click', function () { showSide(b.dataset.side); });
    });
    // Beim Öffnen der Vorschau immer mit der Vorderseite starten
    var previewBtn = $('preview-btn');
    if (previewBtn) { previewBtn.addEventListener('click', function () { showSide('front'); }); }
    var live = $('live-preview-canvas');
    if (live) { live.addEventListener('click', function () { showSide('front'); }); }
    var form = document.querySelector('form[action*="/cart/add"]');
    kachelWechselAbfangen();
    // Versteckte Felder ins Produktformular (wie designer-preview.js)
    if (form) {
      ['designer-hidden-back', 'designer-hidden-back-line1', 'designer-hidden-back-line2', 'designer-hidden-back-line3'].forEach(function (id) {
        var f = $(id);
        if (f && !form.contains(f)) { form.appendChild(f); }
      });
    }
    zuruecksetzen();
    // Manche Browser füllen Formulare erst nach DOMContentLoaded wieder auf
    window.addEventListener('load', function () { if (!nutzerHatEingegeben) { zuruecksetzen(); } });
    // Seite aus dem Zurück-Cache (bfcache): Zustand stammt vom letzten Besuch
    window.addEventListener('pageshow', function (e) { if (e.persisted) { zuruecksetzen(); } });
    setTimeout(hinweisAktualisieren, 600);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
